var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',[_c('div',[_vm._t("title")],2),_c('div',{staticClass:"grid-wrapper cols",class:[`cols-${_vm.cols}`, `${_vm.className}`]},[_vm._t("default")],2),(_vm.$slots.buttons)?_vm._t("buttons"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }